import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installConsoleGuard } from './console-guard';

if (environment.production) {
  enableProdMode();
}

if(window && !environment.showLog){
  window.console.log=function(){};
}

// Logged objects are otherwise kept alive by any attached DevTools/CDP client
if (window && !environment.liveConsoleObjects) {
  // console.log is already a no-op when showLog is false — don't snapshot args just to drop them
  installConsoleGuard(window.console, environment.showLog ? [] : ['log']);
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js', { scope: '/firebase-cloud-messaging-push-scope' })
    .then(() => console.log('SW registered'))
    .catch(err => console.error('SW registration failed', err));
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error("ERROR loading main module"));
